import { Canvas } from 'datocms-react-ui';
import TagDistributionGraph from '../components/TagDistributionGraph';
import { RenderPageCtx } from 'datocms-plugin-sdk';
import ArticlesWithoutStoriesList from '../components/ArticlesWithoutStoriesList/ArticlesWithoutStoriesList';

type Props = {
  ctx: RenderPageCtx;
};

export default function PerisyncAnalyticsPage({ ctx }: Props) {

  return <>
    <Canvas ctx={ctx}>
      <div style={{display: "flex"}}>
        <div style={{width: "50%"}}>
          <TagDistributionGraph type='Articles' />
        </div>
        <div style={{width: "50%"}}>
          <TagDistributionGraph type='Stories' />
        </div>
      </div>
    </Canvas>
    <br/>
    <ArticlesWithoutStoriesList/>
  </>
}
